import React, { useEffect, useState } from "react";
import {
  Checkbox,
  DatePicker,
  Form,
  Modal,
  Select,
  Upload,
  message,
  notification,
  Row,
  Col,
} from "antd";
import { ScholarshipService_ } from "services/scholarship.service";
import { useForm } from "antd/lib/form/Form";
import { Input, InputNumber, Button } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { API_BASE_URL, API_UPLOAD_URL } from "configs/AppConfig";
import { beforeUpload } from "utils/utilities";
import { PlusOutlined } from "@ant-design/icons";
import { useForceUpdate } from "hooks/useForceUpdate";
import { cloneDeep } from "lodash";
import moment from "moment";
import { useQuill } from "react-quilljs";
import { Docs } from "views/app-views/scholarships/components/Docs";
import "./style.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Scrollbars from "react-custom-scrollbars-2";
import { GetLocalStorage } from "utils/common";
import useBreakpoint from "hooks/useBreakpoint";
import DOMPurify from "dompurify";

const ScholarshipInput = ({ scholarshipInfo, buttonStyle, termsStyle }) => {
  const history = useHistory();
  const { quill, quillRef } = useQuill();
  const mobileWidth = window.innerWidth < 750;
  const { isMobileAndTablet } = useBreakpoint();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentFieldIndex, setCurrentFieldIndex] = useState(null);
  const [quillContent, setQuillContent] = useState("");

  const [currentSchoolLevel, setCurrentSchoolLevel] = useState();
  const [currentSchoolLevelId, setCurrentSchoolLevelId] = useState();
  const [formFields, setFormFields] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [ageField, setAgeField] = useState(null);
  const [form] = useForm();
  const forceUpdate = useForceUpdate();
  const [termModalVisible, setTermModalVisible] = useState(false);
  const [privacyModalVisible, setPrivacyModalVisible] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (scholarshipInfo?.fields) {
      scholarshipInfo?.fields?.forEach((scholarshipField) => {
        if (scholarshipField?.field?.key === "age")
          setAgeField(scholarshipField);
      });
    }
  }, [scholarshipInfo]);

  // Initialize Quill content when modal opens
  useEffect(() => {
    if (quill && isModalOpen && currentFieldIndex !== null) {
      const currentValue = form.getFieldValue([
        "applicantFields",
        currentFieldIndex,
        "fieldValue",
      ]);
      if (currentValue && typeof currentValue === "string") {
        // Check if it's HTML content or plain text
        if (currentValue.includes("<") && currentValue.includes(">")) {
          // It's HTML, paste as HTML
          quill.clipboard.dangerouslyPasteHTML(currentValue);
        } else {
          // It's plain text, set as text
          quill.setText(currentValue);
        }
      } else {
        quill.setText("");
      }
    }
  }, [quill, isModalOpen, currentFieldIndex]);

  useEffect(() => {
    const fetchFormFields = async () => {
      try {
        let formFields = GetLocalStorage("formFields");
        if (!formFields) {
          formFields = await getRegisterApplicantsFormFields();
        }

        let requiredParsing = Array.isArray(formFields);

        let parsedFormFields = null;
        if (formFields) {
          try {
            parsedFormFields = !requiredParsing
              ? JSON.parse(formFields)
              : formFields;
            setFormFields(parsedFormFields);
          } catch (parseError) {
            console.error("JSON parse error:", parseError);
          }
        }

        let formFieldData = parsedFormFields;

        if (!formFieldData) {
          const response = await fetch(
            `${API_BASE_URL}api/v1/register-applicants/form-fields`
          );
          const res = await response.json();
          formFieldData = res?.data || [];
        }
        console.log("🚀 ~ fetchFormFields ~ formFieldData:", formFieldData);
      } catch (error) {
        console.error("Error fetching form fields:", error);
        notification.error({
          message: "Failed to load form fields. Please try again later.",
        });
      }
    };
    fetchFormFields();
  }, []);

  async function getRegisterApplicantsFormFields() {
    try {
      const response = await ScholarshipService_.getFormFields();
      return response.data;
    } catch (error) {
      console.error("Error fetching form fields:", error);
      message.error("Failed to load form fields. Please try again later.");
    }
  }

  const handleModalSave = () => {
    if (quill && currentFieldIndex !== null) {
      const content = quill.root.innerHTML;
      setQuillContent(content);

      // Update form field value
      const fieldValue = form.getFieldValue("applicantFields") || [];

      // Ensure the field exists at the current index
      if (!fieldValue[currentFieldIndex]) {
        fieldValue[currentFieldIndex] = {};
      }

      fieldValue[currentFieldIndex] = {
        ...fieldValue[currentFieldIndex],
        fieldValue: content,
      };

      form.setFieldsValue({
        applicantFields: fieldValue,
      });

      setIsModalOpen(false);
      setCurrentFieldIndex(null);
      forceUpdate();
    }
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setCurrentFieldIndex(null);
    setQuillContent("");
  };

  const openEditorModal = (fieldIndex) => {
    setCurrentFieldIndex(fieldIndex);
    setIsModalOpen(true);
  };

  function containsHttpInFirst20Words(inputString) {
    const words = inputString.split(/\s+/).slice(0, 20);

    const first20Words = words.join(" ");

    const urlPattern = /https?:\/\/[^\s]+/;

    return urlPattern.test(first20Words);
  }

  const handleTermsClick = () => {
    const termsLink = "https://lenny.ai/terms";
    if (containsHttpInFirst20Words(scholarshipInfo?.terms)) {
      window.open(scholarshipInfo?.terms, "_blank");
    } else {
      setTermModalVisible(true);
    }
  };

  // Handle click for Privacy policy
  const handlePrivacyClick = () => {
    const privacyLink = "https://lenny.ai/privacy";
    if (containsHttpInFirst20Words(scholarshipInfo?.privacy)) {
      window.open(privacyLink, "_blank");
    } else {
      setPrivacyModalVisible(true);
    }
  };

  const submitApplication = () => {
    setIsLoading(true);
    form.validateFields().then((data) => {
      console.log(data);
      const { firstName, lastName, ...restData } = data;

      // Concatenate first and last names into a single "name" field
      const fullName = `${firstName} ${lastName}`;

      // Add the concatenated name to the form data
      restData.name = fullName;
      restData.firstName = firstName;
      restData.lastName = lastName;
      // Add scholarshipId to the form data
      restData.scholarshipId = scholarshipInfo.id;

      ScholarshipService_.submitApplication(scholarshipInfo.id, restData)
        .then((data) => {
          if (data?.data?.id) {
            // notification.success({
            //   description: "Applicant has been successfully submitted",
            //   message: "Submitted",
            // });
            const modal = Modal.success({
              title: "Application Submitted",
              content: "Applicant has been successfully submitted.",
            });

            // Close the modal automatically after 3 seconds
            setTimeout(() => modal.destroy(), 3000);
            form.resetFields();
          }
        })
        .catch((error) => {
          // Extract the error message from the response
          console.log("error", error);
          const errorMessage =
            error?.description ||
            "An unexpected error occurred.Please try again";

          // Show an error modal
          Modal.error({
            title: "Application Failed",
            content: errorMessage,
          });
        })
        .finally(() => setIsLoading(false));
    });
  };

  function isDOBFieldRequired() {
    const eligibilityType = ageField?.attributes?.eligibilityType;
    const eligibilityValue = ageField?.attributes?.eligibilityValue;
    // DOB field is required only if both eligibilityType and eligibilityValue are defined
    return (
      eligibilityType !== undefined &&
      eligibilityType !== null &&
      eligibilityValue !== undefined &&
      eligibilityValue !== null
    );
  }

  function validateAge(value) {
    const eligibilityType = ageField?.attributes?.eligibilityType;
    const eligibilityValue = ageField?.attributes?.eligibilityValue;

    if (!value) {
      return true;
    }

    // If eligibilityType or eligibilityValue is null/undefined, field is not required
    // if (!eligibilityType || !eligibilityValue) {
    //   return true;
    // }

    const currentDate = moment();
    let age = currentDate.diff(value, "years");

    // Check if the user is born in the current year but hasn't had their birthday yet
    const hasBirthdayPassed =
      currentDate.month() > value.month() ||
      (currentDate.month() === value.month() &&
        currentDate.date() >= value.date());

    if (!hasBirthdayPassed) {
      age--;
    }

    switch (eligibilityType) {
      case "is":
        return {
          isValid: age?.toString() === eligibilityValue,
          errorMessage: `Age should be exactly ${eligibilityValue}`,
        };
      case "lessthanOrIs":
        return {
          isValid: age <= eligibilityValue,
          errorMessage: `Age should be less than or equal to ${eligibilityValue}`,
        };
      case "greaterthanOrIs":
        return {
          isValid: age >= eligibilityValue,
          errorMessage: `Age should be greater than or equal to ${eligibilityValue}`,
        };
      default:
        return { isValid: true, errorMessage: null };
    }
  }

  function validateDate(value, scholarshipField) {
    const eligibilityType = scholarshipField?.attributes?.eligibilityType;
    const eligibilityValue = scholarshipField?.attributes?.eligibilityValue;

    if (!eligibilityType || !eligibilityValue || !value) {
      return true;
    }

    const fieldName = scholarshipField?.field?.name;
    switch (eligibilityType) {
      case "between":
        return {
          isValid: moment(value).isBetween(
            moment(eligibilityValue[0], "DD/MM/YYYY"),
            moment(eligibilityValue[1], "DD/MM/YYYY")
          ),
          errorMessage: `${fieldName} should be between ${moment(
            eligibilityValue[0],
            "DD/MM/YYYY"
          ).format("DD/MM/YYYY")} and ${moment(
            eligibilityValue[1],
            "DD/MM/YYYY"
          ).format("DD/MM/YYYY")}`,
        };
      case "before":
        return {
          isValid: moment(value).isBefore(
            moment(eligibilityValue, "DD/MM/YYYY")
          ),
          errorMessage: `${fieldName} should be before ${moment(
            eligibilityValue,
            "DD/MM/YYYY"
          ).format("DD/MM/YYYY")}`,
        };
      case "after":
        return {
          isValid: moment(value).isAfter(
            moment(eligibilityValue, "DD/MM/YYYY")
          ),
          errorMessage: `${fieldName} should be after ${moment(
            eligibilityValue,
            "DD/MM/YYYY"
          ).format("DD/MM/YYYY")}`,
        };
      default:
        return { isValid: true, errorMessage: null };
    }
  }

  // Helper function to safely get option label from both old and new formats
  const getOptionLabel = (optionData) => {
    if (typeof optionData === "string") {
      return optionData; // Old format: simple string
    } else if (
      optionData &&
      typeof optionData === "object" &&
      optionData.name
    ) {
      return optionData.name; // New format: object with name property
    }
    return String(optionData); // Fallback
  };

  function validateOption(value, scholarshipField) {
    const eligibilityType = scholarshipField?.attributes?.eligibilityType;
    const eligibilityValue = scholarshipField?.attributes?.eligibilityValue;

    if (!eligibilityValue || !value) {
      return true; // no eligibilityValue provided, always valid
    }
    let validValues = []; // eligibility Value  in terms of keys
    let matchValues = []; // eligibility Value  in terms of options value
    if (Array.isArray(eligibilityValue)) {
      validValues = eligibilityValue;
    } else {
      validValues = eligibilityValue.split(",");
    }
    matchValues = validValues.map((key) => {
      const optionData = scholarshipField?.field.options[key];
      return getOptionLabel(optionData);
    });

    const strValues = matchValues.join(", ");
    const fieldName = scholarshipField?.field?.name;

    const isValid = validValues.includes(value); // check if the selected value is in the eligible values array
    switch (eligibilityType) {
      case "is":
        return {
          isValid,
          errorMessage: `${fieldName} should equal to ${strValues}`,
        };
      case "oneOf":
        return {
          isValid,
          errorMessage: `${fieldName} should one of  ${strValues}`,
        };
      case "not":
        return {
          isValid: !isValid,
          errorMessage: `${fieldName} should one of  ${strValues}`,
        };
      case "notOneOf":
        return {
          isValid: !isValid,
          errorMessage: `${fieldName} should be different from ${strValues} `,
        };
      default:
        return { isValid: true, errorMessage: null }; // unsupported eligibilityType
    }
  }

  const getDynamicFields = () => {
    const allFieldExceptAge = scholarshipInfo?.fields?.filter(
      (field) => field.field.key !== "age"
    );

    return [
      ...(allFieldExceptAge ?? []),
      ...(scholarshipInfo?.requirements ?? []),
    ].map((scholarshipField, i) => {
      return prepareFieldOptions(scholarshipField, i);
    });
  };

  const handleChange = (info, namePath) => {
    const fieldValue = form.getFieldValue("applicantFields") || [];
    const fieldIndex = namePath[1];

    if (info?.file?.status === "removed") {
      // Only clear upload value, keep editor content if it exists
      const currentField = fieldValue[fieldIndex] || {};
      const currentValue = currentField.fieldValue;

      // If current value looks like HTML (from editor), keep it; otherwise clear
      if (
        currentValue &&
        typeof currentValue === "string" &&
        currentValue.includes("<") &&
        currentValue.includes(">")
      ) {
        // Keep editor content
      } else {
        fieldValue[fieldIndex] = {
          ...currentField,
          fieldValue: null,
        };
      }
    } else if (info?.file?.status === "done") {
      const responseData = info?.file?.response?.data;
      if (responseData) {
        const { publicUrl } = responseData;
        const currentField = fieldValue[fieldIndex] || {};

        // If there's existing editor content, append the file URL
        const existingContent = currentField.fieldValue;
        let newValue = publicUrl;

        if (
          existingContent &&
          typeof existingContent === "string" &&
          existingContent.includes("<") &&
          existingContent.includes(">")
        ) {
          // Append file link to existing editor content
          newValue =
            existingContent +
            `<br><a href="${publicUrl}" target="_blank">Uploaded File</a>`;
        }

        fieldValue[fieldIndex] = {
          ...currentField,
          fieldValue: newValue,
        };
      }
    } else if (info?.file?.status === "error") {
      console.error("File upload failed:", info.file.error);
    }

    // Update form field value
    form.setFieldsValue({
      applicantFields: fieldValue,
    });

    forceUpdate();
  };

  const getUploadIcon = (namePath) => {
    return form.getFieldValue(namePath) ? null : (
      <div
        style={{
          color: "black",
        }}
      >
        <PlusOutlined />
        <div className="ant-upload-text" style={{ color: "black" }}>
          Upload
        </div>
      </div>
    );
  };
  const today = moment().endOf("day");
  const minAge = 16;
  const maxDateOfBirth = moment().subtract(minAge, "years").endOf("day");

  const formItemStyle = {
    paddingLeft: "10px",
    paddingRight: "10px",
    backgroundColor: "#F0F1FF",
    borderRadius: "4px",
    width: "100%",
  };

  const inputStyle = {
    backgroundColor: "#F0F1FF",
    color: "black",
    border: "1px solid #ccc",
  };

  const prepareFieldOptions = (scholarshipField, i) => {
    const field_ = scholarshipField?.field;
    console.log("🚀 ~ prepareFieldOptions ~ field_:", field_);
    const isFieldOptional = scholarshipField?.optional;
    const isRequired = isFieldOptional === true;
    const isRequirement = field_?.type === "requirement";
    let fieldName = isRequirement ? scholarshipField?.title : field_?.name;
    let fieldDescription = isRequirement ? scholarshipField?.description : null;
    fieldName = fieldName ?? field_?.name;

    const requiredRule = isRequired
      ? [{ required: true, message: `Please enter/select ${fieldName}` }]
      : [];
    switch (field_?.dataType) {
      case "option":
        return (
          <Col xs={24} sm={24}>
            <span key={scholarshipField.id}>
              <Form.Item
                style={{ paddingLeft: "10px", paddingRight: "10px" }}
                name={["applicantFields", i, "fieldId"]}
                hidden
                initialValue={field_.id}
              >
                <Input />
              </Form.Item>
              <Form.Item
                style={{}}
                name={["applicantFields", i, "fieldValue"]}
                label={
                  <div
                    style={{
                      display: "block", // Ensures it takes the full width
                      color: "black",
                      width: "100%", // Set to full width
                    }}
                  >
                    <p
                      style={{
                        margin: "0",
                        whiteSpace: "normal", // Allows text wrapping
                        width: "100%", // Ensure full width
                        color: "black",
                      }}
                    >
                      {fieldName} {/* Title */}
                    </p>
                    {fieldDescription && (
                      <div
                        style={{
                          color: "gray",
                          marginTop: "5px",
                          width: "100%",
                          margin: "0",
                        }}
                      >
                        {fieldDescription} {/* Description */}
                      </div>
                    )}
                  </div>
                }
                rules={[
                  {
                    required: scholarshipField?.attributes?.optional === false,
                  },
                  {
                    validator: (rule, value, callback) => {
                      const validateResult = validateOption(
                        value,
                        scholarshipField
                      );
                      callback(
                        !validateResult?.isValid
                          ? validateResult?.errorMessage
                          : undefined
                      );
                    },
                  },
                ]}
              >
                <Select
                  options={Object.keys(field_.options ?? {}).map((key) => ({
                    label: getOptionLabel(field_.options[key]),
                    value: key,
                  }))}
                  placeholder={`Select ${fieldName}`}
                  className="custom-select-option"
                />
              </Form.Item>
            </span>
          </Col>
        );
      case "link":
        return (
          <Col xs={24} sm={12}>
            <div key={scholarshipField.id} style={{ width: "100%" }}>
              {/* Hidden Field */}
              <Form.Item
                style={
                  {
                    // paddingLeft: "10px",
                    // paddingRight: "10px",
                  }
                }
                name={["applicantFields", i, "fieldId"]}
                hidden
                initialValue={field_.id || ""}
              >
                <Input />
              </Form.Item>

              {/* Field Item with Title as Label */}
              <Form.Item
                style={{
                  // paddingLeft: "10px",
                  // paddingRight: "10px",
                  width: "100%",
                }}
                name={["applicantFields", i, "fieldValue"]}
                //initialValue={field_.id || ""}
                label={
                  <div
                    style={{
                      display: "block", // Ensures it takes the full width
                      color: "black",
                      width: "100%", // Set to full width
                    }}
                  >
                    <p
                      style={{
                        margin: "0",
                        whiteSpace: "normal", // Allows text wrapping
                        width: "100%", // Ensure full width
                        color: "black",
                      }}
                    >
                      {fieldName} {/* Title */}
                    </p>
                    {fieldDescription && (
                      <div
                        style={{
                          color: "gray",
                          marginTop: "5px",
                          width: "100%",
                          margin: "0",
                        }}
                      >
                        {fieldDescription} {/* Description */}
                      </div>
                    )}
                  </div>
                }
                rules={requiredRule}
              >
                <Input
                  style={{ width: "100%", ...inputStyle }}
                  placeholder="Enter link here"
                />
              </Form.Item>
            </div>
          </Col>
        );
      case "checkbox":
        return (
          <Col xs={24} sm={12}>
            <span key={scholarshipField.id}>
              {/* Hidden Field ID */}
              <Form.Item
                style={{}}
                name={["applicantFields", i, "fieldId"]}
                hidden
                initialValue={field_.id}
              >
                <Input style={{ ...inputStyle }} />
              </Form.Item>

              {/* Single Checkbox with Label */}
              <Form.Item
                style={{}}
                name={["applicantFields", i, "fieldValue"]}
                valuePropName="checked" // Needed for single checkbox (boolean)
                rules={[
                  {
                    required: true,
                    message: `Please enter/select ${fieldName}`,
                  },
                ]}
                label={
                  <div
                    style={{
                      display: "block", // Ensures it takes the full width
                      color: "black",
                      width: "100%", // Set to full width
                    }}
                  >
                    <p
                      style={{
                        // marginBottom: "5px",
                        margin: "0",
                        whiteSpace: "normal", // Allows text wrapping
                        width: "100%", // Ensure full width
                        color: "black",
                      }}
                    >
                      {fieldName} {/* Title */}
                    </p>
                  </div>
                }
              >
                <Checkbox>{fieldDescription}</Checkbox>
              </Form.Item>

              {/* Description Below */}
              {/* {fieldDescription && (
              <div
                style={{
                  color: "gray",
                  marginTop: "0px",
                  marginBottom: "10px",
                  paddingLeft: "0",
                  paddingRight: "10px",
                }}
              >
                {fieldDescription}
              </div>
            )} */}
            </span>
          </Col>
        );
      case "file": {
        const namePath = ["applicantFields", i, "fieldValue"];
        return (
          <span key={scholarshipField.id}>
            {/* Field Label and Description */}
            <div
              style={{
                color: "black",
                marginBottom: "4px",
                paddingLeft: isMobileAndTablet ? "10px" : undefined,
              }}
            >
              <p
                style={{
                  margin: "0px",
                  // marginBottom: "5px",
                  whiteSpace: "normal",
                  color: "black",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                {fieldName}
              </p>
              {fieldDescription && (
                <div style={{ color: "gray" }}>{fieldDescription}</div>
              )}
            </div>

            {/* Hidden fieldId */}
            <Form.Item
              name={["applicantFields", i, "fieldId"]}
              hidden
              initialValue={field_.id}
            >
              <Input />
            </Form.Item>

            {/* Upload and Editor Button - aligned horizontally */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Form.Item name={namePath} rules={requiredRule}>
                <Upload
                  name="file"
                  action={API_UPLOAD_URL}
                  onChange={(info) => handleChange(info, namePath)}
                  onPreview={(file) => {
                    window.open(
                      file?.response?.data?.publicUrl,
                      "_blank",
                      "noreferrer"
                    );
                  }}
                  showUploadList={true}
                >
                  <div
                    style={{
                      cursor: "pointer",
                      color: "#7681FF",
                      border: "1px dashed #d9d9d9",
                      padding: "8px 16px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <PlusOutlined
                      style={{
                        fontSize: "12px",
                        marginRight: "8px",
                        color: "#7681FF",
                      }}
                    />
                    Upload
                  </div>
                </Upload>
              </Form.Item>

              {/* Open Editor Button */}
              <button
                onClick={() => openEditorModal(i)}
                type="button"
                style={{
                  padding: "8px 16px",
                  backgroundColor: form.getFieldValue([
                    "applicantFields",
                    i,
                    "fieldValue",
                  ])
                    ? "transparent"
                    : "#7681FF",
                  color: form.getFieldValue([
                    "applicantFields",
                    i,
                    "fieldValue",
                  ])
                    ? "black"
                    : "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  height: "40px",
                  whiteSpace: "nowrap",
                  ...(form.getFieldValue([
                    "applicantFields",
                    i,
                    "fieldValue",
                  ]) && {
                    textDecoration: "underline",
                    color: "#7681FF",
                  }),
                }}
              >
                {form.getFieldValue(["applicantFields", i, "fieldValue"])
                  ? "View"
                  : "Open Editor"}
              </button>
            </div>
          </span>
        );
      }
      // case "text":
      case "editor":
        return (
          <Col xs={24} sm={12}>
            <span key={scholarshipField.id}>
              <Form.Item
                style={{}}
                name={["applicantFields", i, "fieldId"]}
                hidden
                initialValue={field_.id}
              >
                <Input />
              </Form.Item>
              <Form.Item
                style={{}}
                name={["applicantFields", i, "fieldValue"]}
                label={
                  <div
                    style={{
                      display: "block", // Ensures it takes the full width
                      color: "black",
                      width: "100%", // Set to full width
                    }}
                  >
                    <p
                      style={{
                        // marginBottom: "5px",
                        margin: "0",
                        whiteSpace: "normal", // Allows text wrapping
                        width: "100%", // Ensure full width
                        color: "black",
                      }}
                    >
                      {fieldName} {/* Title */}
                    </p>
                    {fieldDescription && (
                      <div
                        style={{
                          color: "gray",
                          marginTop: "5px",
                          width: "100%",
                          margin: "0",
                        }}
                      >
                        {fieldDescription} {/* Description */}
                      </div>
                    )}
                  </div>
                }
                rules={requiredRule}
              >
                {/* <TextArea />
                 */}
                <button
                  onClick={() => {
                    openEditorModal(i);
                  }}
                  type="button"
                  style={{
                    marginTop: "10px",
                    marginLeft: "10px",
                    padding: "8px 16px",
                    backgroundColor: form.getFieldValue([
                      "applicantFields",
                      i,
                      "fieldValue",
                    ])
                      ? "transparent"
                      : "#7681FF",
                    color: form.getFieldValue([
                      "applicantFields",
                      i,
                      "fieldValue",
                    ])
                      ? "black"
                      : "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    ...(form.getFieldValue([
                      "applicantFields",
                      i,
                      "fieldValue",
                    ]) && {
                      textDecoration: "underline",
                      color: "#7681FF",
                    }),
                  }}
                >
                  {form.getFieldValue(["applicantFields", i, "fieldValue"])
                    ? "View"
                    : "Open Editor"}
                </button>
              </Form.Item>
            </span>
          </Col>
        );

      case "text":
        return (
          <Col xs={24} sm={24} className="ant-row ant-form-item">
            <div key={scholarshipField.id} style={{ width: "100%" }}>
              {/* Hidden Field */}
              <Form.Item
                style={
                  {
                    // paddingLeft: "10px",
                    // paddingRight: "10px",
                  }
                }
                name={["applicantFields", i, "fieldId"]}
                hidden
                initialValue={field_.id || ""}
                placeholder={`Enter ${fieldName} here`}
              >
                <Input />
              </Form.Item>

              {/* Field Item with Title as Label */}
              <Form.Item
                style={{
                  // paddingLeft: "10px",
                  // paddingRight: "10px",
                  width: "100%",
                }}
                placeholder={`Enter ${fieldName} here`}
                name={["applicantFields", i, "fieldValue"]}
                //initialValue={field_.id || ""}
                label={
                  <div
                    style={{
                      display: "block", // Ensures it takes the full width
                      color: "black",
                      width: "100%", // Set to full width
                    }}
                  >
                    <p
                      style={{
                        margin: "0px",
                        // marginBottom: "5px",
                        whiteSpace: "normal", // Allows text wrapping
                        width: "100%", // Ensure full width
                        color: "black",
                      }}
                    >
                      {fieldName} {/* Title */}
                    </p>
                    {fieldDescription && (
                      <div
                        style={{
                          color: "gray",
                          marginTop: "5px",
                          width: "100%",
                        }}
                      >
                        {fieldDescription} {/* Description */}
                      </div>
                    )}
                  </div>
                }
                rules={[
                  {
                    required: scholarshipField?.attributes?.optional === false,
                  },
                ]}
              >
                <Input
                  style={{ width: "100%", ...inputStyle }}
                  placeholder={`Enter ${fieldName} here`}
                />
              </Form.Item>
            </div>
          </Col>
        );
      case "link":
      case "email":
      case "phone":
      case "number":
      default:
        return (
          <Col xs={24} sm={12}>
            <div key={scholarshipField.id} style={{ width: "100%" }}>
              {/* Hidden Field */}
              <Form.Item
                style={
                  {
                    // paddingLeft: "10px",
                    // paddingRight: "10px",
                  }
                }
                name={["applicantFields", i, "fieldId"]}
                hidden
                initialValue={field_.id || ""}
              >
                <Input />
              </Form.Item>

              {/* Field Item with Title as Label */}
              <Form.Item
                style={{
                  // paddingLeft: "10px",
                  // paddingRight: "10px",
                  width: "100%",
                }}
                name={["applicantFields", i, "fieldValue"]}
                //initialValue={field_.id || ""}
                label={
                  <div
                    style={{
                      display: "block", // Ensures it takes the full width
                      color: "black",
                      width: "100%", // Set to full width
                    }}
                  >
                    <p
                      style={{
                        margin: "0px",
                        // marginBottom: "5px",
                        whiteSpace: "normal", // Allows text wrapping
                        width: "100%", // Ensure full width
                        color: "black",
                      }}
                    >
                      {fieldName} {/* Title */}
                    </p>
                    {fieldDescription && (
                      <div
                        style={{
                          color: "gray",
                          marginTop: "5px",
                          width: "100%",
                        }}
                      >
                        {fieldDescription} {/* Description */}
                      </div>
                    )}
                  </div>
                }
                rules={[
                  {
                    required: scholarshipField?.attributes?.optional === false,
                  },
                  {
                    type: ["email", "number"].includes(field_?.dataType)
                      ? field_?.dataType
                      : "string",
                  },
                ]}
              >
                <Input style={{ width: "100%", ...inputStyle }} />
              </Form.Item>
            </div>
          </Col>
        );
    }
  };

  const onGoBack = () => {};

  const goBack = () => {};

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={submitApplication}
        style={{ color: "black", width: "100%" }}
      >
        {isMobileAndTablet ? (
          <>
            <Row gutter={[16, 16]}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: mobileWidth ? "100%" : "1fr 1fr",
                  gap: "12px",
                  width: "100%",
                }}
              >
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={<span style={{ color: "black" }}>First Name</span>}
                    name="firstName"
                    rules={[
                      {
                        required: true,
                        message: "Please input your first name!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter your first name"
                      style={{ backgroundColor: "#F0F1FF", color: "black" }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={<span style={{ color: "black" }}>Last Name</span>}
                    name="lastName"
                    rules={[
                      {
                        required: true,
                        message: "Please input your last name!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter your last name"
                      style={{ backgroundColor: "#F0F1FF", color: "black" }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    name="email"
                    label={<span style={{ color: "black" }}>Email</span>}
                    rules={[{ type: "email", required: true }]}
                  >
                    <Input
                      placeholder="Enter your email"
                      style={{ backgroundColor: "#F0F1FF", color: "black" }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    name="phone"
                    label={<span style={{ color: "black" }}>Phone</span>}
                    rules={[{ min: 10, max: 13 }]}
                  >
                    <Input
                      placeholder="91-9999999999"
                      style={{ backgroundColor: "#F0F1FF", color: "black" }}
                    />
                  </Form.Item>
                </Col>

                {true && (
                  // {isDOBFieldRequired() && (
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="dob"
                      label={
                        <span style={{ color: "black" }}>Date of Birth</span>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Date of Birth is required",
                        },
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.reject(
                                "Please select a valid date."
                              );
                            }
                            if (moment(value).isAfter(moment(), "day")) {
                              return Promise.reject(
                                "Date of Birth cannot be in the future."
                              );
                            }
                            const result = validateAge(value);
                            if (!result?.isValid) {
                              return Promise.reject(result?.errorMessage);
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <DatePicker
                        style={{
                          width: "100%",
                          backgroundColor: "#F0F1FF",
                          color: "white",
                        }}
                        placeholder="Select your date of birth"
                        disabledDate={(current) =>
                          current && current.isAfter(maxDateOfBirth)
                        }
                        defaultPickerValue={maxDateOfBirth}
                      />
                    </Form.Item>
                  </Col>
                )}
                {getDynamicFields()}
              </div>

              <div style={{ marginTop: 24 }}>
                <Col xs={24} sm={12}>
                  <Checkbox
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                  />
                  <span style={{ paddingLeft: 8 }}>
                    I agree to the{" "}
                    <a
                      href="https://lenny.ai/terms"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ cursor: "pointer", color: "#8D96FF" }}
                    >
                      Terms of use
                    </a>
                    ,{" "}
                    <a
                      href="https://lenny.ai/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ cursor: "pointer", color: "#8D96FF" }}
                    >
                      Privacy policy
                    </a>{" "}
                    and{" "}
                    <a
                      onClick={handleTermsClick}
                      style={{ cursor: "pointer", color: "#8D96FF" }}
                    >
                      the Scholarship Terms
                    </a>
                    .
                  </span>
                </Col>
              </div>
            </Row>
          </>
        ) : (
          <Scrollbars
            // ref={scrollbarsRef}
            width={"100%"}
            autoHide
            autoHideTimeout={1000}
            autoHideDuration={200}
            style={{
              width: "100%",
              height: `calc(100dvh - 340px)`,
              margin: "auto",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: mobileWidth ? "100%" : "1fr 1fr",
                gap: "12px",
                width: "100%",
              }}
            >
              <Form.Item
                label={<span style={{ color: "black" }}>First Name</span>}
                name="firstName"
                rules={[
                  { required: true, message: "Please input your first name!" },
                ]}
              >
                <Input
                  placeholder="Enter your first name"
                  style={{ backgroundColor: "#F0F1FF", color: "black" }}
                />
              </Form.Item>

              <Form.Item
                label={<span style={{ color: "black" }}>Last Name</span>}
                name="lastName"
                rules={[
                  { required: true, message: "Please input your last name!" },
                ]}
              >
                <Input
                  placeholder="Enter your last name"
                  style={{ backgroundColor: "#F0F1FF", color: "black" }}
                />
              </Form.Item>

              <Form.Item
                name="email"
                label={<span style={{ color: "black" }}>Email</span>}
                rules={[{ type: "email", required: true }]}
              >
                <Input
                  placeholder="Enter your email"
                  style={{ backgroundColor: "#F0F1FF", color: "black" }}
                />
              </Form.Item>

              <Form.Item
                name="phone"
                label={<span style={{ color: "black" }}>Phone</span>}
                rules={[{ min: 10, max: 13 }]}
              >
                <Input
                  placeholder="91-9999999999"
                  style={{ backgroundColor: "#F0F1FF", color: "black" }}
                />
              </Form.Item>

              {true && (
                // {isDOBFieldRequired() && (
                <Form.Item
                  name="dob"
                  label={<span style={{ color: "black" }}>Date of Birth</span>}
                  rules={[
                    { required: true, message: "Date of Birth is required" },
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.reject("Please select a valid date.");
                        }
                        if (moment(value).isAfter(moment(), "day")) {
                          return Promise.reject(
                            "Date of Birth cannot be in the future."
                          );
                        }
                        const result = validateAge(value);
                        if (!result?.isValid) {
                          return Promise.reject(result?.errorMessage);
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <DatePicker
                    style={{
                      width: "100%",
                      backgroundColor: "#F0F1FF",
                      color: "white",
                    }}
                    placeholder="Select your date of birth"
                    disabledDate={(current) =>
                      current && current.isAfter(maxDateOfBirth)
                    }
                    defaultPickerValue={maxDateOfBirth}
                  />
                </Form.Item>
              )}
              {getDynamicFields()}
            </div>

            <div style={{ marginTop: 24 }}>
              <Checkbox
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
              />
              <span style={{ paddingLeft: 8 }}>
                I agree to the{" "}
                <a
                  href="https://lenny.ai/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ cursor: "pointer", color: "#8D96FF" }}
                >
                  Terms of use
                </a>
                ,{" "}
                <a
                  href="https://lenny.ai/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ cursor: "pointer", color: "#8D96FF" }}
                >
                  Privacy policy
                </a>{" "}
                and{" "}
                <a
                  onClick={handleTermsClick}
                  style={{ cursor: "pointer", color: "#8D96FF" }}
                >
                  the Scholarship Terms
                </a>
                .
              </span>
            </div>
          </Scrollbars>
        )}

        <Form.Item
          style={{ textAlign: "center", marginTop: 24, marginBottom: 32 }}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{
              width: "auto",
              backgroundColor: "#8D96FF",
              marginTop: "8px",
              // color: "white",
            }}
            disabled={!isChecked}
          >
            Submit Application
          </Button>
        </Form.Item>
      </Form>

      <Modal
        title="Terms and Conditions"
        visible={termModalVisible}
        onOk={() => setTermModalVisible(false)}
        onCancel={() => setTermModalVisible(false)}
        style={{
          top: 20,
          maxWidth: "80%",
          width: "80%",
          maxHeight: "80%",
          overflowY: "auto",
        }}
        footer={null}
      >
        <p
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(scholarshipInfo?.terms),
          }}
        />
      </Modal>

      <Modal
        title="Privacy Policy"
        visible={privacyModalVisible}
        onOk={() => setPrivacyModalVisible(false)}
        onCancel={() => setPrivacyModalVisible(false)}
      >
        <p>{scholarshipInfo?.privacy}</p>
      </Modal>

      <Modal
        // title={"Edit Scholarship Requirements"}
        // visible={isModalOpen}
        // onOk={handleModalSave}
        // onCancel={handleModalCancel}
        // okText="Save"
        // cancelText="Discard Changes"
        // width={800}
        // style={{ top: 20 }}
        // bodyStyle={{ height: "400px" }}
        // footer={
        //   <Button
        //     key="submit"
        //     type="primary"
        //     onClick={handleModalSave}
        //     style={{ backgroundColor: "rgba(16, 49, 184, 1)" }}
        //   >
        //     Save
        //   </Button>
        // }
        centered
        closable={false}
        visible={isModalOpen}
        onCancel={handleModalCancel}
        footer={null}
        width="80%"
        bodyStyle={{
          height: "auto",
          // height: "80dvh",
          overflowY: "auto",
          padding: "0px",
          borderRadius: "24px",
        }}
        className="custom-modal"
      >
        <div style={{ padding: "8px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <a
              onClick={() => {
                // if (onGoBack) onGoBack();
                // else history.goBack();
                handleModalCancel();
              }}
              style={{
                color: "#1D252D",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src="/new/back.png"
                style={{ height: "22px", marginRight: "6px" }}
              />
              <p
                style={{
                  fontWeight: "500",
                  fontSize: "18px",
                  margin: "0",
                  color: "black",
                }}
              >
                <span style={{ color: "#8D96FF" }}>{"Editor"}</span>
                {/* {field.name} - <span style={{ color: "#8D96FF" }}>{title}</span> */}
              </p>
            </a>
            <Button
              type="primary"
              // onClick={saveClick}
              onClick={handleModalSave}
              style={{
                color: "#8D96FF",
                borderRadius: "8px",
                background: "transparent",
                border: "none",
                fontWeight: "500",
                fontSize: "18px",
                boxShadow: "none",
                width: "max-content",
              }}
            >
              <span>Submit</span>
            </Button>
          </div>
        </div>

        <div
          style={
            {
              // paddingLeft: "20px", paddingRight: "20px"
            }
          }
        >
          <div ref={quillRef} style={{ minHeight: "400px" }} />
        </div>
        {/* <div
          ref={quillRef}
          style={{
            height: "300px",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
          }}
        /> */}
      </Modal>
    </div>
  );
};

export default ScholarshipInput;
